import React, {useState, useEffect, useRef} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { actionToAddToCart } from "../../../redux/action";
import useAuth from "../../../redux/hooks/useAuth";
import {formatImageTitle, formatPrice, getPriceAfterDiscount} from "../../../redux/utility/jwtUtils";
import ArrowUp from "../../../assets/images/category/Arrow_up-removebg-preview.png";
import ArrowDown from "../../../assets/images/category/Arrow_down-removebg-preview.png";
import RatingComponent from "../product/RatingComponent";

const ProductDetail = () => {
    const { auth } = useAuth();
    const [quantity, setQuantity] = useState(1);
    const [activeImage, setActiveImage] = useState("");
    const productDetailData = useSelector((state) => state.product.productDetailData);

    const dispatch = useDispatch();
    const salePrice = getPriceAfterDiscount(productDetailData);

    const imageContainerRef = useRef(null);
    const [isZoomed, setIsZoomed] = useState(false);
    const [position, setPosition] = useState({ x: 0, y: 0 });



    useEffect(() => {
        if (productDetailData?.photo) {
            setActiveImage(productDetailData.photo); // Set initial active image
        }
    }, [productDetailData]);

    const addToCart = () => {
        let products = { product_id: productDetailData.id, quantity: quantity };
        dispatch(actionToAddToCart(products, auth?.id));
    };

    const handleIncrease = () => {
        setQuantity((prevQuantity) => prevQuantity + 1);
    };

    const handleDecrease = () => {
        if (quantity > 1) {
            setQuantity((prevQuantity) => prevQuantity - 1);
        }
    };

    const ratingOfProduct=(ratings)=>{
        return ratings.reduce((acc, obj) => acc + obj.rating, 0) / ratings?.length;
    }
    const handleImageClick = (image) => {
        setActiveImage(image); // Change the active image
    };

    const scrollUp = () => {
        if (imageContainerRef.current) {
            imageContainerRef.current.scrollBy({ top: -100, behavior: 'smooth' });
        }
    };

    const handleMouseEnter = () => {
        setIsZoomed(true);
    };

    const handleMouseMove = (e) => {
        const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
        const xPos = ((e.pageX - left) / width) * 100;
        const yPos = ((e.pageY - top) / height) * 100;

        setPosition({ x: xPos, y: yPos });
    };

    const handleMouseLeave = () => {
        setIsZoomed(false);
    };

    const scrollDown = () => {
        if (imageContainerRef.current) {
            imageContainerRef.current.scrollBy({ top: 100, behavior: 'smooth' });
        }
    };

    if (!productDetailData) {
        return <h2>Product not found</h2>;
    }

    return (
        <div className='product-details'>
            <div className='product-details-left '>
                <div className='productdetails-img-list-container'>
                    {productDetailData.photos?.length > 2 && (
                        <button className="scroll-arrow up-arrow" onClick={scrollUp}>
                            <img src={ArrowUp}
                                 alt={'arrow up - Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project'}
                                 title={'arrow up - Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project'}
                                 className='arrow-up-down' />
                        </button>
                    )}
                    <div className='productdetails-img-list' ref={imageContainerRef}>
                        <img
                            key={'main-image'}
                            src={productDetailData.photo}
                            alt={formatImageTitle(productDetailData.name)+' main image - Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project'}
                            title={formatImageTitle(productDetailData.name)+' main image - Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project'}
                            onClick={() => handleImageClick(productDetailData.photo)}
                            className={activeImage === productDetailData.photo ? 'active-image' : ''}
                        />
                        {productDetailData.photos?.map((photos, index) => (
                            <img
                                key={index}
                                src={photos.photo}
                                alt={formatImageTitle(productDetailData.name)+' image '+index+'- Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project'}
                                title={formatImageTitle(productDetailData.name)+' image '+index+'- Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project'}
                                onClick={() => handleImageClick(photos.photo)}
                                className={activeImage === photos.photo ? 'active-image' : ''}
                            />
                        ))}
                    </div>
                    {productDetailData.photos?.length > 2 && (
                        <button className="scroll-arrow down-arrow" onClick={scrollDown}>
                            <img src={ArrowDown}
                                 alt={'arrow down - Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project'}
                                 title={'arrow down - Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project'}
                                 className='arrow-up-down' />
                        </button>
                    )}
                </div>
                <div
                    className={`productdetails-img ${isZoomed ? "zoom-active" : ""}`}
                    onMouseEnter={handleMouseEnter}
                    onMouseMove={handleMouseMove}
                    onMouseLeave={handleMouseLeave}
                >
                    <img
                        className='productdetails-main-img'
                        src={activeImage}
                        alt={formatImageTitle(productDetailData.name) + ' active image - Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project'}
                        title={formatImageTitle(productDetailData.name) + ' active image - Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project'}
                        style={isZoomed ? { transformOrigin: `${position.x}% ${position.y}%` } : {}}
                    />
                </div>
            </div>
            <div className='product-details-right'>
                <h1>{productDetailData.name}</h1>
                <div className='productdetails-right-star'>
                    {productDetailData.ratings > 0 && <RatingComponent rating={ratingOfProduct(productDetailData.ratings)}/>}
                </div>
                <div className='productdetails-right-prices'>
                    {salePrice !== productDetailData.sale_price ? (
                        <>
                            <div className='productdetails-right-price-old'>
                                 {formatPrice(productDetailData.sale_price)}
                            </div>
                            <div className='productdetails-right-price-new'>
                               {formatPrice(salePrice)}
                            </div>
                        </>
                    ) : (
                        <div className='productdetails-right-price'>{formatPrice(salePrice)} </div>
                    )}
                </div>
                <div
                    className='productdetails-right-description'
                    dangerouslySetInnerHTML={{ __html: productDetailData?.description }}
                ></div>
                <div className='productdetails-right-quantity'>
                    <h2>Select Quantity :</h2>
                    <div className="quantity-controls">
                        {quantity > 1 && (
                            <button className="quantity-btn" onClick={handleDecrease}>
                                <FontAwesomeIcon icon={faMinus} />
                            </button>
                        )}
                        <span className="quantity">{quantity}</span>
                        {quantity < 5 && (
                            <button className="quantity-btn" onClick={handleIncrease}>
                                <FontAwesomeIcon icon={faPlus} />
                            </button>
                        )}
                    </div>
                </div>
                <button className='button' onClick={addToCart}>Add to Cart</button>
                <p className='productdisplay-right-category'>
                    {/*<span>Category :</span> {productDetailData.subcategory_name}*/}
                </p>
            </div>
        </div>
    );
};

export default ProductDetail;
